import { render, staticRenderFns } from "./jrDetail.vue?vue&type=template&id=10a66d90&scoped=true&"
import script from "./jrDetail.vue?vue&type=script&lang=js&"
export * from "./jrDetail.vue?vue&type=script&lang=js&"
import style0 from "./jrDetail.vue?vue&type=style&index=0&id=10a66d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a66d90",
  null
  
)

export default component.exports